
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/blog",
      function () {
        return require("private-next-pages/preview/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/blog"])
      });
    }
  